// extracted by mini-css-extract-plugin
export default {"cardContainer":"AboutContainer_cardContainer__PmGCV"};